import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { View, Text, Button } from '@olxbr/design-system'
import TimeAgo from 'javascript-time-ago'
import pt from 'javascript-time-ago/locale/pt'
import HRule from '../../atoms/HRule'
import Link from '../../atoms/Link'
import LoginHistory from '../../molecules/LoginHistory'
import * as historyApi from '../../../api/history'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
`

const HistoryDiv = styled(View)`
  margin: 0;
`

const HRuleWrapper = styled(View)`
  margin-top: 14px;
  margin-bottom: 14px;
`

const Suggestion = styled(Text)`
  font-size: 14px;
  font-weight: 400;
`

const ButtonWrapper = styled(View)`
  margin-top: 24px;
  width: 200px;
`

class LoginHistoryControlBlock extends React.Component {
  constructor(props) {
    super(props)
    TimeAgo.addLocale(pt)
    this.state = {
      isDeleting: false,
      loading: false,
      lurker: props.lurker,
      timeAgo: new TimeAgo('pt-BR'),
    }
  }

  componentDidMount() {
    this.fetchSessions()
  }

  fetchSessions = () => {
    this.setState({ loading: true })
    historyApi
      .getSessions()
      .then((data = []) => {
        this.setState({
          loading: false,
          sessions: this.transformDataToSessions(data),
        })
      })
      .catch(() =>
        this.setState({
          loading: false,
          sessions: [],
        })
      )
  }

  transformDataToSessions = data => {
    const { timeAgo } = this.state
    let sessions = []
    data.forEach(session => {
      sessions.push({
        id: session.ID,
        deviceType: session.device_type,
        deviceName: session.device_name,
        location: session.session_location,
        lastActivityAge: timeAgo.format(new Date(session.created_at)),
      })
    })
    return sessions
  }

  lurkerClickEvt = detail => {
    const { lurker } = this.state
    if (lurker && typeof lurker.clickEvt === 'function') {
      lurker.clickEvt(detail)
    }
  }

  onChangePasswordClick = () => {
    const { onChangePassword } = this.props
    if (onChangePassword && typeof onChangePassword === 'function') {
      onChangePassword('link')
    }
  }

  onFinishSessionsClick = () => {
    this.lurkerClickEvt('delete_sessions')
    this.setState({ isDeleting: true }, this.onDeleteCall)
  }

  onDeleteCall = () => {
    const { onSuccess, onError } = this.props
    historyApi
      .deleteSessions()
      .then(deleted => {
        if (deleted && onSuccess && typeof onSuccess === 'function') {
          onSuccess()
        }
      })
      .catch(() => {
        if (onError && typeof onError === 'function') {
          onError()
        }
      })
      .finally(() => this.setState({ isDeleting: false }))
  }

  render() {
    const { isDeleting, sessions, loading } = this.state
    const isButtonDisabled = isDeleting || loading
    return (
      <Content>
        <Text size="title3" weight="bold">
          Histórico de conexões
        </Text>
        <Text size="caption" color="grayscale.darker">
          Todos os aparelhos (computadores, celulares e tablets) em que sua conta da OLX esteve
          conectada nos últimos 30 dias.
        </Text>

        {!loading && (
          <HistoryDiv>
            <LoginHistory sessions={sessions} />
          </HistoryDiv>
        )}

        <HRuleWrapper>
          <HRule />
        </HRuleWrapper>

        <Suggestion>
          Não reconhece uma conexão?{' '}
          <Link
            type="primary"
            underline={false}
            onClick={this.onChangePasswordClick}
            preventHrefOnClick={!!this.props.onChangePassword}
          >
            Altere sua senha
          </Link>
        </Suggestion>

        <HRuleWrapper>
          <HRule />
        </HRuleWrapper>

        <Text size="body1" wight="bold">
          Encerrar a sessão em todos os aparelhos
        </Text>
        <Text size="caption" color="grayscale.darker">
          Todos os aparelhos (computadores, celulares e tablets) em que sua conta da OLX estiver
          ativa serão desconectados.
        </Text>
        <ButtonWrapper>
          <Button
            fluid
            size="medium"
            onClick={this.onFinishSessionsClick}
            isLoading={isDeleting}
            disabled={isButtonDisabled}
          >
            Encerrar sessões
          </Button>
        </ButtonWrapper>
      </Content>
    )
  }
}

LoginHistoryControlBlock.defaultProps = {
  loading: false,
}

LoginHistoryControlBlock.propTypes = {
  loading: PropTypes.bool,
  lurker: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onChangePassword: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func,
}

export default LoginHistoryControlBlock
